<template>
  <span class="flex rounded-md shadow-sm" :class="{ 'w-full': wFull }">
    <button
      :type="buttonType"
      :class="cssClasses"
      :disabled="disabled"
      v-if="!isLink"
    >
      <!--<span v-if="hasIcon"><icons-component :icon="icon" class="h-4 w-4"></icons-component></span>-->
      <slot></slot>
    </button>
    <a
      :href="href"
      :class="cssClasses"
      :disabled="disabled"
      :target="target"
      v-if="isLink"
    >
      <!--<div v-if="hasIcon"><icons-component :icon="icon" class="h-4 w-4"></icons-component></div>-->
      <slot></slot>
    </a>
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: "md",
  },
  buttonType: {
    type: String,
    default: "button",
  },
  color: {
    type: String,
    default: "primary",
  },
  href: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  target: {
    type: String,
    default: "_top",
  },
  icon: {
    type: String,
    default: "",
  },
  wFull: {
    type: Boolean,
    default: true,
  },
});

const cssClasses = computed(() => {
  return {
    "inline-flex": true,
    "justify-center": true,
    "w-full": props.wFull,

    border: true,
    "leading-5": true,
    "font-medium": true,
    "rounded-md": true,
    "focus:outline-none": true,
    transition: true,
    "ease-in-out": true,
    "duration-150": true,
    "sm:text-sm": true,
    "sm:leading-5": true,

    /* size xl */
    "px-4": props.size === "xl" || props.size === "md",
    "py-4": props.size === "xl",
    "text-xl": props.size === "xl",

    /* size md */
    "py-2": props.size === "md",
    "text-sm": props.size === "md",

    /* size sm */
    "px-2.5": props.size === "sm",
    "py-1.5": props.size === "sm",
    "text-xs": props.size === "sm" || props.size === "xs",

    /* size xs */
    "px-1.5": props.size === "xs",
    "py-1": props.size === "xs",

    /* color primary */
    "text-white":
      props.color === "primary" ||
      props.color === "error" ||
      props.color === "warning",
    "border-transparent": props.color === "primary",
    "bg-primary-800": props.color === "primary" && !props.disabled,
    "bg-primary-200": props.color === "primary" && props.disabled,
    "hover:bg-primary-600": props.color === "primary" && !props.disabled,
    "focus:border-primary-600": props.color === "primary",
    "focus:ring-primary": props.color === "primary",
    "active:bg-primary-700": props.color === "primary",

    /* color default */
    "border-gray-300": props.color === "default",
    "text-gray-700": props.color === "default" && !props.disabled,
    "text-gray-300": props.color === "default" && props.disabled,
    "bg-white": props.color === "default",
    "hover:bg-gray-50": props.color === "default" && !props.disabled,
    "focus:ring-primary-500": props.color === "default",

    /* color error */
    "bg-red-600": props.color === "error" && !props.disabled,
    "bg-red-300": props.color === "error" && props.disabled,
    "hover:bg-red-500": props.color === "error" && !props.disabled,
    "focus:border-red-700": props.color === "error",
    "focus:ring-red": props.color === "error",
    "active:bg-red-700": props.color === "error",

    /* color warning */
    "bg-yellow-500": props.color === "warning" && !props.disabled,
    "bg-yellow-300": props.color === "warning" && props.disabled,
    "hover:bg-yellow-600": props.color === "warning" && !props.disabled,
    "focus:border-yellow-700": props.color === "warning",
    "focus:ring-yellow": props.color === "warning",
    "active:bg-yellow-700": props.color === "warning",

    "cursor-not-allowed": props.disabled,
  };
});

const hasIcon = computed(() => {
  return props.icon !== "";
});

const isLink = computed(() => {
  return props.href !== "";
});
</script>
